module.exports = __webpack_public_path__ + "img/index_banner02.53b389a8.jpg";